import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Form, Input, Button, message, DatePicker, Spin } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en";
import locale from "antd/es/date-picker/locale/en_US";
import BackRouteButton from "src/common/components/BackRouteButton";

import "./index.css";

export default ({ editAnalysis, profile, analyses }) => {
  const location = useLocation();
  const [form] = Form.useForm();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [analysis, setAnalysis] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    values._id = analysis._id;
    values.creatorId = profile._id;

    const result = await editAnalysis(values);
    if (result.success) {
      form.resetFields();
      message.success("Analysis successfully updated!");
      history.goBack();
    } else {
      message.error(result.message || "Failed to update analysis!");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (analyses) {
      const id = location.state.analysis._id;
      for (var analysis of analyses) {
        if (analysis._id === id) {
          setAnalysis(analysis);
          break;
        }
      }
    }
  }, [analyses]);

  useEffect(() => {
    if (analysis) {
      var formattedDate = dayjs(analysis.date).format("DD.MM.YYYY");
      formattedDate = dayjs(formattedDate, "DD.MM.YYYY");

      form.setFieldsValue({
        date: formattedDate,
        wheat: analysis.wheat,
        flour: analysis.flour,
      });
      setLoading(false);
    }
  }, [analysis, form]);

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">Edit Analysis</h4>
        <Form
          requiredMark={false}
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            label="Date:"
            name="date"
            rules={[
              {
                required: true,
                message: "Please select the analysis date!",
              },
            ]}
          >
            <DatePicker
              size="small"
              locale={locale}
              format="DD.MM.YYYY"
              style={{
                width: "50%",
              }}
            />
          </Form.Item>

          <Form.Item label="Flour Data:" name="flour">
            <Input.TextArea />
          </Form.Item>

          <Form.Item label="Wheat Data:" name="wheat">
            <Input.TextArea />
          </Form.Item>

          <Form.Item>
            <Button type="primary" block size="medium" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};
